import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { MdBookmark, MdDelete, MdBookmarkBorder } from 'react-icons/md'
import { useDispatch, useSelector } from 'react-redux'
import history from '../../../lib/history'
import routes from '../../../config/routes'
import * as reducks from '../../../reducks'
import Flex from '../../commons/Flex/Flex'
import Text from '../../commons/Text/Text'
import Tag from '../../commons/Tag/Tag'
import DefaultLayout from '../../commons/Layouts/DefaultLayout'
import Button from '../../commons/Button/Button'
import Card from '../../commons/Card/Card'
import Thumbnail from '../../commons/Thumbnail/Thumbnail'
import Box from '../../commons/Icons/Box'
import Chat from '../../commons/Icons/Chat'
import Process from '../../commons/Icons/Process'
import MegaPhone from '../../commons/Icons/MegaPhone'
import LoadingBounce from '../../commons/LoadingBounce/LoadingBounce'
import BoyNoContent from '../../commons/Ilustrations/BoyNoContent'
import Breadcrumb from '../../commons/Breadcrumb/Breadcrumb'
import styles from './contentSearch.module.scss'

const ContentSearch = (props) => {
  const {
    match: {
      params: { search }
    }
  } = props

  if (!search) return null

  const breadcrumbs = [
    {
      id: 1,
      title: 'Conteúdos',
      path: routes.content.path
    },
    {
      id: 2,
      title: 'Busca'
    }
  ]

  const dispatch = useDispatch()

  const knowledgeBaseReducer = useSelector(
    (store) => store.knowledgeBaseReducer
  )

  const redirectToDetail = (item) => {
    history.push(routes.contentDetail.path.replace(':contentId', item.id))
  }

  const applyFilter = (category) => {
    dispatch(
      reducks.resources.knowledgeBase.actions.setFilters({
        categoryId: category.id
      })
    )
    dispatch(reducks.resources.knowledgeBase.actions.getRecents({ search }))
  }

  const clearFilters = () => {
    dispatch(
      reducks.resources.knowledgeBase.actions.setFilters({
        categoryId: null
      })
    )
    setTimeout(() => {
      dispatch(reducks.resources.knowledgeBase.actions.getRecents({ search }))
    }, 500)
  }

  useEffect(() => {
    dispatch(reducks.resources.knowledgeBase.actions.getCategories())
  }, [])

  useEffect(() => {
    if (search)
      dispatch(
        reducks.resources.knowledgeBase.actions.getRecents({
          search
        })
      )
  }, [search])

  const renderIconPerType = (icon) => {
    switch (icon) {
      case 4:
        return <Box />
      case 2:
        return <Chat />
      case 3:
        return <Process />
      default:
        return <MegaPhone />
    }
  }

  const handlePagination = () => {
    if (
      knowledgeBaseReducer.recents.pagination.currentPage >
      knowledgeBaseReducer.recents.pagination.lastPage
    )
      return null

    return dispatch(
      reducks.resources.knowledgeBase.actions.getRecents({
        fetchMore: true,
        search
      })
    )
  }

  const hasPages =
    knowledgeBaseReducer.recents.pagination.currentPage !==
    knowledgeBaseReducer.recents.pagination.lastPage

  return (
    <DefaultLayout>
      <Flex column>
        <Text
          size="lg"
          color="gray"
          variation="dark"
          extraBold
          lineHeight="30px"
          value={`Resultado da busca: "${search}”`}
        />
      </Flex>

      <Breadcrumb items={breadcrumbs} />
      <Flex column>
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            marginTop: 30,
            flexWrap: 'wrap'
          }}
        >
          {knowledgeBaseReducer.categories.fetching && <LoadingBounce />}
          {!knowledgeBaseReducer.categories.fetching &&
            knowledgeBaseReducer.categories.list.length && (
              <>
                {knowledgeBaseReducer.categories.list.map((item) => (
                  <Tag
                    onClick={() => applyFilter(item)}
                    size="xs"
                    key={item.id}
                    active={item.id === knowledgeBaseReducer.filters.categoryId}
                    text={item.name}
                    white
                  />
                ))}

                <Button width="160px" onClick={clearFilters}>
                  <Text
                    color="gray"
                    variation="dark"
                    size="xxs"
                    extraBold
                    margin="0px 10px 0px 0px"
                  >
                    Limpar
                  </Text>
                  <MdDelete />
                </Button>
              </>
            )}
        </div>

        <div className={styles.row}>
          {!knowledgeBaseReducer.recents.fetching &&
            knowledgeBaseReducer.recents.list.map((item) => (
              <Card key={item.id} className={styles.cardGrid}>
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    flex: 1
                  }}
                >
                  <div
                    onClick={() => redirectToDetail(item)}
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      width: '100%'
                    }}
                  >
                    <div>
                      <Thumbnail
                        gradient
                        type={item.category.code}
                        className={styles.icon}
                      >
                        {renderIconPerType(item.category.code)}
                      </Thumbnail>
                    </div>
                    <Flex column>
                      <Text
                        size="xs"
                        lineHeight="24px"
                        color="gray"
                        variation="dark"
                        bold
                        className={styles.elipsis}
                      >
                        {item.title}
                      </Text>
                      <Text
                        size="xxs"
                        lineHeight="18px"
                        color="gray"
                        variation="light"
                        font="custom"
                        margin="5px 0px 0px 0px"
                      >
                        {item.lastUpdateFormatted}
                      </Text>
                    </Flex>
                  </div>
                  <div
                    style={{
                      display: 'flex',
                      flexDirection: 'column',
                      justifyContent: 'flex-end',
                      height: '100%'
                    }}
                  >
                    <button
                      type="button"
                      style={{
                        background: 'none',
                        border: 0,
                        outline: 'none'
                      }}
                      onClick={() => {
                        dispatch(
                          reducks.resources.knowledgeBase.actions.toggleFavorite(
                            {
                              key: 'recents',
                              item
                            }
                          )
                        )
                      }}
                    >
                      {!item.isFavorite ? (
                        <MdBookmarkBorder color="#4d4d4d" size={20} />
                      ) : (
                        <MdBookmark color="#4d4d4d" size={20} />
                      )}
                    </button>
                  </div>
                </div>
              </Card>
            ))}
        </div>
        <Flex column alignItems="center" justifyContent="center" width="94%">
          {(knowledgeBaseReducer.recents.fetching ||
            knowledgeBaseReducer.recents.fetchingMore) && (
            <div style={{ padding: 20 }}>
              <LoadingBounce />
            </div>
          )}
          {hasPages &&
            (!knowledgeBaseReducer.recents.fetching ||
              !knowledgeBaseReducer.recents.fetchingMore) && (
              <button
                type="button"
                onClick={() => handlePagination()}
                className={styles.actionWhite}
              >
                <Text
                  font="custom"
                  color="gray"
                  variation="dark"
                  size="xs"
                  fontWeight="600"
                  lineHeight="20px"
                >
                  ver mais
                </Text>
              </button>
            )}
        </Flex>
        {!knowledgeBaseReducer.recents.fetching &&
          knowledgeBaseReducer.recents.list.length === 0 && (
            <Card className={styles.empty}>
              <Flex column alignItems="center" justifyContent="center" flex="1">
                <BoyNoContent />
                <Text
                  size="md"
                  color="gray"
                  variation="dark"
                  extraBold
                  lineHeight="24px"
                  margin="32px 0px 16px 0px"
                >
                  Conteúdos
                </Text>
                <Text size="xs" color="gray" font="custom" fontWeight="400">
                  Ainda não existe nenhum conteúdo.
                </Text>
              </Flex>
            </Card>
          )}
      </Flex>
    </DefaultLayout>
  )
}

ContentSearch.defaultProps = {
  match: {
    params: {
      search: null
    }
  }
}

ContentSearch.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      search: PropTypes.string
    })
  })
}

export default ContentSearch
